import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=14454272&"
import script from "./Radio.vue?vue&type=script&lang=ts&"
export * from "./Radio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports